<template>
  <div class="track">
    <div class="track__progress-container">
      <div class="track__progress-container--wrapper">
        <div
          class="track__progress-bar"
          :style="{
            background:
              props.hasDynamicColors && (primaryColor || defaultColor),
            width: `${props.progress}%`,
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import useBackgroundColor from '@/composables/useBackgroundColor';

defineOptions({
  name: 'AppProgress',
});

const props = defineProps({
  progress: {
    type: Number,
    default: 0,
  },
  hasDynamicColors: {
    type: Boolean,
    default: false,
  },
});

const { primaryColor, defaultColor } = useBackgroundColor();
</script>

<style lang="scss" scoped>
$primary: #f37c82;
$barBG: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.3);
$barSize: 4px;
$chaptersBG: black;
$chapterBG: #2e2e2e;
$chaptersColor: #fff;

.track {
  position: relative;
  width: 100%;
  align-self: flex-start;
  user-select: none;

  &__progress-container {
    position: relative;
    overflow: hidden;
    cursor: pointer;

    &--wrapper {
      overflow: hidden;
      position: relative;
      height: $barSize;
      border-radius: $barSize;
      background: $barBG;
    }
  }

  &__progress-bar {
    position: absolute;
    width: 0;
    height: $barSize;
    border-radius: $barSize;
    background: $primary;
    z-index: 1;
  }
}
</style>
